<template>
  <div class="w-100">
    <div class="w-100 mb-3-1 d-flex justify-content-between addt_srv_cart" v-for="(product,product_i) in products">
      <div class="image" v-if="!product.hideImage">
        <img :src="product.image_url" class="img-fit" >
      </div>
      <div class="w-100 px-3" @click="togglePopupDetail(product)">
        <p class="mb-0 text-white body-2-4">{{product.name}}</p>
        <p class="mb-0 body-3 text-white">{{product.qty}} {{ product.unit ? product.unit : 'x' }}</p>
        <p v-if="product.form_flight_number !== 'HIDE'" class="text-12 text-white mt-1 mb-0 cursor-pointer"><span class="font-lato-regular">Flight Number : </span> <span class="font-lato underline">{{ $isNotEmptyV2(product.flight_number) ? product.flight_number : "click to add" }}</span></p>
      </div>
      <div class="d-flex flex-column pl-2 h-auto">
        <div class="text-right mb-2">
          <p class="text-12 font-lato mb-0 text-white">{{ $formatCurrency(product.price.finalWithTax) }}</p>
          <p class="text-10 font-lato-regular text-white mb-0 text-line-through" v-if="product.promotion.promotionName">{{ $formatCurrency(product.price.baseWithTax) }}</p>
        </div>
        <div class="remove-btn ml-auto" @click="removeProduct(product)">
          <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_201_6878)">
              <path
                d="M4.96216 14.3925C4.67027 14.3925 4.48316 14.2204 4.46819 13.936L4.24366 5.69563C4.23617 5.41871 4.42328 5.23908 4.72266 5.23908C4.99958 5.23908 5.19418 5.41123 5.20166 5.68815L5.44116 13.936C5.44865 14.2129 5.25405 14.3925 4.96216 14.3925ZM7.24494 14.3925C6.953 14.3925 6.75093 14.2129 6.75093 13.936V5.69563C6.75093 5.41871 6.953 5.23908 7.24494 5.23908C7.53681 5.23908 7.74636 5.41871 7.74636 5.69563V13.936C7.74636 14.2129 7.53681 14.3925 7.24494 14.3925ZM9.53514 14.3925C9.24327 14.3925 9.04867 14.2129 9.05614 13.936L9.28817 5.69563C9.29564 5.41123 9.49024 5.23908 9.76717 5.23908C10.0665 5.23908 10.2536 5.41871 10.2462 5.69563L10.0216 13.936C10.0067 14.2204 9.81954 14.3925 9.53514 14.3925ZM3.95925 3.42037H5.14927V1.81871C5.14927 1.3921 5.44865 1.11517 5.89772 1.11517H8.57714C9.02619 1.11517 9.32559 1.3921 9.32559 1.81871V3.42037H10.5156V1.74387C10.5156 0.658628 9.81207 0 8.65946 0H5.81538C4.66278 0 3.95925 0.658628 3.95925 1.74387V3.42037ZM0.56133 4.01913H13.936C14.2428 4.01913 14.4898 3.75717 14.4898 3.45031C14.4898 3.14345 14.2428 2.88898 13.936 2.88898H0.56133C0.261954 2.88898 0 3.14345 0 3.45031C0 3.76466 0.261954 4.01913 0.56133 4.01913ZM3.81705 16.6678H10.6803C11.7505 16.6678 12.469 15.9717 12.5214 14.9014L13.0453 3.86196H1.44449L1.97588 14.909C2.02827 15.9792 2.73181 16.6678 3.81705 16.6678Z"
                fill="#DC3545" />
            </g>
            <defs>
              <clipPath id="clip0_201_6878">
                <rect width="14.4898" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>

    <b-modal 
      v-model="showPopupDetail" 
      @hidden="togglePopupDetail()"
      ref="product_detail" 
      centered size="sm" hide-header hide-footer body-class="p-3" footer-class="p-0">
      <div class="w-100">
        <div v-if="$isNotEmptyV2(popupData)" class="w-100 mb-3 pb-3 border-b-form d-flex justify-content-between addt_srv_cart">
          <div class="image" v-if="!popupData.hideImage">
            <img :src="popupData.image_url" class="img-fit" >
          </div>
          <div class="w-100 px-3">
            <p class="mb-0 body-2-4">{{popupData.name}}</p>
            <div class="d-flex align-items-center mb-1 ">
              <p class="text-12 font-lato mb-0">{{ $formatCurrency(popupData.price.finalWithTax) }}</p>
              <p class="text-10 font-lato-regular mb-0 text-line-through ml-2" v-if="popupData.promotion.promotionName">{{ $formatCurrency(popupData.price.baseWithTax) }}</p>
            </div>
            <p class="mb-0 body-3">{{popupData.qty}} {{ popupData.unit ? popupData.unit : 'x' }}</p>
          </div>
        </div>
        <div class="w-100 mb-3 pb-3 border-b-form">
          <p class="mb-2 body-3-1">Flight Number :</p>
          <input 
            type="text" 
            class="px-3 py-2 font-lato text-14 w-100 radius-6"  
            :class="$v.flightNumberInput.$error ? 'border-danger' : 'border-form'"
            v-model="flightNumberInput" >
          <span v-if="$v.flightNumberInput.$error" class="mb-0 text-10 font-lato text-danger">Flight number is requried</span>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <button class="w-50 mr-1 g-btn g-btn-light g-btn-md" @click="togglePopupDetail()">Close</button>
          <button class="w-50 ml-1 g-btn g-btn-primary g-btn-md" @click="saveFlightNumber()">Save</button>
        </div>
      </div>
    </b-modal>
    
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import { validationMixin } from "vuelidate";
  import { isEmpty } from 'lodash';
  const { helpers } = require("vuelidate/lib/validators");

  const skipIfNoRequiredPopup = (detail) => {
    return helpers.withParams({ type: "skipIfNoRequiredPopup" }, function (value, parentVm) {
      if(isEmpty(detail)) return true;
      const isRequired = detail.form_flight_number === 'REQUIRED';
      return isRequired && isEmpty(value) ? false : true;
    });
  }
  
  const skipIfNoRequiredList = () => {
    return helpers.withParams({ type: "skipIfNoRequiredList" }, function (value, parentVm) {
      if(isEmpty(parentVm)) return true;
      const isRequired = parentVm.form_flight_number === 'REQUIRED';
      return isRequired && isEmpty(value) ? false : true;
    });
  }
  
  export default {
    props: ['products'],
    data(){
      return {
        showPopupDetail: false,
        popupData: null,
        flightNumberInput: ""
      }
    },
    computed:{
      totalProduct(){
        return this.products.length;
      },
      generalValidation(){
        return this.getAdditionalServiceValidation
      }
    },
    watch:{
      totalProduct(newData, oldData){
        if(oldData < newData){
          this.$v.products.$reset();
        }
      },
      generalValidation(newData, oldData){
        if(newData === 'START'){
          this.validateFlightNumberInList();
        }
      }
    },
    mixins: [validationMixin],
    validations(){
      return {
        flightNumberInput:{
          skipIfNoRequiredPopup: skipIfNoRequiredPopup(this.popupData || {})
        },
        products:{
          $each:{
            flight_number: {
              skipIfNoRequiredList: skipIfNoRequiredList()
            }
          }
        }
      }
    },
    methods:{
      ...mapMutations(['BeSaveOtherDataAddtService']),
      togglePopupDetail(data=null){
        if(data === null){
          this.showPopupDetail = false;
          this.flightNumberInput = "";
          this.popupData = null;
        }else{
          if(data.form_flight_number === "HIDE") return;
          this.showPopupDetail = true;
          this.popupData = this.$deepCopy(data);
          this.flightNumberInput = this.popupData.flight_number
        }
      },
      removeProduct(product){
        this.$emit('removeProduct', product)
      },
      validateFlightNumberInList(){
        this.$v.products.$reset();
        this.$v.products.$touch();

        const isValid = !this.$v.products.$invalid

        this.setAdditionalServiceValidation(isValid ? 'VALID' : 'INVALID');
        if(!isValid){
          const indexNotValid = Object.values(this.$v.products.$each.$iter).findIndex(parent => parent.$error);
          if(indexNotValid != -1){
            const roomRateSelected = this.products[indexNotValid];
            this.togglePopupDetail(roomRateSelected);
            setTimeout(() => {
              this.validateFlightNumber();
            }, 300);
          }
        }
        
        return isValid;
      },
      validateFlightNumber(){
        this.$v.flightNumberInput.$reset();
        this.$v.flightNumberInput.$touch();
        return !this.$v.flightNumberInput.$invalid;
      },
      
      saveFlightNumber(){
        if(!this.validateFlightNumber()) return;
        
        const payload = {
          key: 'flight_number',
          value: this.flightNumberInput,
          detail: this.popupData.ref_data.data
        }
        this.BeSaveOtherDataAddtService(payload);
        setTimeout(() => {
          this.togglePopupDetail();
        }, 200);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ProductCartPrimaryStyle.vue